export * from './app-upload-file.module';



// WEBPACK FOOTER //
// ./src/app/components/app-upload-file/index.ts